<article class="viewerAsset viewerAssetIFrame w-100 d-flex justify-content-between">
  <div class="viewerAssetIFrameWrapper mx-auto">
    <iframe id="iframeContainer"
            class="w-100 h-100 border-0"
            [src]="iframeUri"
            (load)="onLoad()"
            allowfullscreen="true"
            allow="fullscreen"
            ></iframe>
  </div>
</article>
